import axios from 'axios';
import config from '../common/config';

export default {
  getBillingProfile(token) {
    return axios.get(`${config.config.ROOT_URL}/billing/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getRidePrice(token, rideId) {
    return axios.get(`${config.config.ROOT_URL}/billing/ride/${rideId}/price`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getMonthlySummary(token) {
    return axios.get(`${config.config.ROOT_URL}/billing/monthly-summary`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  payForRide(token, rideId, payload = null) {
    return axios.post(
      `${config.config.ROOT_URL}/billing/ride/${rideId}/pay`,
      payload || {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
  },

  getMonthlyPaymentMethod(token) {
    return axios.get(`${config.config.ROOT_URL}/billing/monthly-payment-method`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  registerMonthlyPaymentMethod(token, body) {
    return axios.post(`${config.config.ROOT_URL}/billing/monthly-payment-method`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  chargeMonthly(token, managerId, year, month, amount) {
    return axios.post(
      `${config.config.ROOT_URL}/billing/admin/charge-monthly`,
      { manager_id: managerId, year, month, amount },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
  },

  adjustRideAmount(token, { userId, rideId, year, month, newAmount }) {
    return axios.post(
      `${config.config.ROOT_URL}/billing/admin/adjust-ride-amount`,
      { user_id: userId, ride_id: rideId, year, month, new_amount: newAmount },
      { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
    );
  },

  addBillingLine(token, { userId, year, month, label, amount }) {
    return axios.post(
      `${config.config.ROOT_URL}/billing/admin/add-billing-line`,
      { user_id: userId, year, month, label, amount },
      { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
    );
  },

  updateBillingLine(token, txId, { amount, label }) {
    return axios.put(
      `${config.config.ROOT_URL}/billing/admin/update-billing-line/${txId}`,
      { amount, label },
      { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
    );
  },

  getCustomerPricing(token) {
    return axios.get(`${config.config.ROOT_URL}/billing/admin/customer-pricing`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  updateCustomerPricing(token, userId, data) {
    return axios.put(
      `${config.config.ROOT_URL}/billing/admin/customer-pricing/${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
  },

};

